import React from "react";
import { TextField } from "@mui/material";

const DescriptionSection = ({
  divesitePara,
  diveDescription,
  oneliner,
  onChange,
}) => (
  <>
    <TextField
      label="Divesite Description"
      value={divesitePara}
      onChange={(e) => onChange("divesitePara", e.target.value)}
      multiline
      fullWidth
    />
    <TextField
      label="Dive Description"
      value={diveDescription}
      onChange={(e) => onChange("diveDescription", e.target.value)}
      multiline
      fullWidth
    />
    <TextField
      label="One line overview"
      value={oneliner}
      onChange={(e) => onChange("oneliner", e.target.value)}
      fullWidth
    />
  </>
);

export default DescriptionSection;
